import { toast as baseToast } from 'vue3-toastify'

// Zentraler Toast-Wrapper. vue3-toastify kündigt Toasts über das role-Attribut
// des Toast-Elements an (role="alert" => assertiv, role="status" => höflich),
// verwendet aber standardmäßig für alle Toasts role="alert". Hier wird die
// Rolle anhand des Toast-Typs gesetzt: Fehler werden assertiv, alle übrigen
// Meldungen höflich angekündigt.
//
// Die Signatur ist identisch zu vue3-toastify (toast(message, options)), sodass
// bestehende Aufrufstellen unverändert bleiben. Eine explizit übergebene role
// hat weiterhin Vorrang.
export const toast = (message, options = {}) => {
  const role = options.type === 'error' ? 'alert' : 'status'
  return baseToast(message, { role, ...options })
}
